import { c as _c } from "react/compiler-runtime";
import { getSinceDateFilterId, getDateRangeFilterId, parseCustomDateFilterId } from "@components/common/faro-table/faro-table-filter/date-filter/date-filter-utils";
import { DateRangePicker } from "@components/date-range-picker/date-range-picker";
import { DatePicker } from "@flat-ui";
import { Box } from "@mui-wrapper";
/** The picker shown in the dropdown of a date filter chip, to pick a date or a date range to filter by */
export function DateFilterCustomPicker(t0) {
  const $ = _c(5);
  const {
    kind,
    activeFilterId,
    onFilterPicked
  } = t0;
  let t1;
  if ($[0] !== activeFilterId || $[1] !== kind || $[2] !== onFilterPicked) {
    const activeSpan = activeFilterId ? parseCustomDateFilterId(activeFilterId) : undefined;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        px: 2,
        pt: 0.5,
        pb: 1
      };
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = <Box sx={t2} onKeyDown={_temp}>{kind === "since" ? <DatePicker date={activeSpan?.start.toJSDate()} maxDate={new Date()} formSx={{
        width: "100%"
      }} onChange={date => {
        if (date) {
          onFilterPicked(getSinceDateFilterId(date));
        }
      }} /> : <DateRangePicker value={activeSpan && [activeSpan.start.toJSDate(), activeSpan.end.startOf("day").toJSDate()]} presets={[]} isFullWidth={true} onAccept={t3 => {
        const [start, end] = t3;
        if (start) {
          onFilterPicked(getDateRangeFilterId(start, end ?? start));
        }
      }} />}</Box>;
    $[0] = activeFilterId;
    $[1] = kind;
    $[2] = onFilterPicked;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp(event) {
  return event.stopPropagation();
}